//AUTHORIZATION
export const SET_AUTH = "setAuth";
export const REMOVE_AUTH = "removeAuth";
export const SET_USER = "setUser";

//LOADER
export const SET_LOADER = "setLoader";
